import styled from 'react-emotion'
import ResponsiveContainer from '../../core/ResponsiveContainer'
import CloudinaryS3LazyLoadedImage from '../../CloudinaryS3LazyLoadedImage'
import Colors from '../../../themes/Colors'
import {
  Typo16WhiteFourDD,
  Typo14PinkishGreyDR,
  Typo12PinkishGreyDR,
  Typo25WhiteDD
} from '../../../themes/Fonts/Din2014'
import { Typo30DarkGreyBlueTwoNBI } from '../../../themes/Fonts/Nort'
import { mobile } from '../../../utils/mixins'

export const TeamProfilesContainer = styled(ResponsiveContainer)``
export const TeamProfilesImageContainer = styled('div')`
  color: green;
`
export const TeamHeading = styled('article')`
  font-family: din-2014;
  font-size: 32px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #344564;
  margin-bottom: 60px;
  text-align: center;
`
export const TeamProfilesImage = styled(CloudinaryS3LazyLoadedImage)`
  width: 7.5em;
  height: 7.5em;
  object-fit: contain;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 70px;
    height: 70px;
    margin-right: 10px;
  }
`
export const TeamProfileContent = styled('div')`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`
export const TeamProfilesCardContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 14em;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 3.375em;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: row;
    width: 85%;
  }
`
export const TeamProfilesName = styled(Typo16WhiteFourDD)`
  color: ${Colors.charcoalGreyTwo};
  letter-spacing: normal;
  text-align: center;
  margin-top: 9px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    margin-top: 0px;
  }
`
export const TeamProfilesDesignation = styled(Typo14PinkishGreyDR)`
  color: ${Colors.charcoalGreyTwo};
  letter-spacing: normal;
  text-align: center;
  @media (min-width: 320px) and (max-width: 425px) {
    text-align: left;
  }
`
export const TeamProfilesUniversity = styled(Typo12PinkishGreyDR)`
  color: ${Colors.charcoalGreyTwo};
  text-align: center;
  margin-top: 0.125em;
`
export const TeamProfilesSection = styled('div')`
  font-size: 16px;
  padding-top: 60px;
  padding-bottom: 60px;
  background: ${Colors.white};
  @media (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    padding-top: 5em;
  }
`
export const TeamProfiles = styled('div')`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`
export const TeamCountSection = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 93.5%;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 320px) and (max-width: 435px) {
    flex-direction: column;
  }
`
export const TeamCountBackground = styled('div')`
  width: 7.5em;
  height: 7.5em;
  border-radius: 68.1px;
  background-color: #0b569a;
`
export const TeamCountDescription = styled(Typo25WhiteDD)`
  color: ${Colors.darkGreyBlue};
  font-weight: normal;
  margin: 0px;
  ${mobile} {
    text-align: center;
  }
`

export const TeamCountSecondBackground = styled('div')`
  width: 7.5em;
  height: 7.5em;
  border-radius: 68.1px;
  background-color: #0b569a;
  margin-left: 7.5em;
  @media (min-width: 320px) and (max-width: 435px) {
    margin-left: 0;
    margin-top: 2.5em;
  }
`

export const TitleContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
  margin-top: 60px;
`
export const Title = styled(Typo30DarkGreyBlueTwoNBI)`
  text-align: center;
  line-height: normal;
  ${mobile} {
    font-size: 24px;
  }
  margin: 0;
`
export const TitleUnderLine = styled('div')`
  width: 100px;
  height: 2px;
  background-color: ${Colors.ceruleanBlue};
  margin: auto;
  margin-top: 10px;
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/TeamProfiles/styledComponents.js